import { z } from "zod";
import { Id, IsoDateTime, Page, PageQuery } from "./common";

export const CommandType = z.enum([
  "ResetDevice",
  "RebootDevice",
  "SetParameter",
  "Ping",
  "RequestStream",
  "RequestDiagnostics",
  "ClearFaultCode",
]);
export type CommandType = z.infer<typeof CommandType>;

export const CommandStatus = z.enum([
  "Requested",
  "Sent",
  "Accepted",
  "Completed",
  "Failed",
  "TimedOut",
  // Non-simulator mode: request is recorded but no adapter dispatch occurs.
  "NotDispatched",
]);
export type CommandStatus = z.infer<typeof CommandStatus>;

export const CommandRequest = z.object({
  commandId: Id,
  tenantId: Id,
  deviceId: Id,
  assetId: Id.nullable(),
  commandType: CommandType,
  status: CommandStatus,
  parameters: z.record(z.unknown()),
  requestedAt: IsoDateTime,
  requestedBy: Id.nullable(),
  lastStatusAt: IsoDateTime,
  failureReason: z.string().max(2000).nullable(),
  createdAt: IsoDateTime,
  updatedAt: IsoDateTime,
});
export type CommandRequest = z.infer<typeof CommandRequest>;

export const CommandResult = z.object({
  commandResultId: Id,
  commandId: Id,
  tenantId: Id,
  deviceId: Id,
  status: CommandStatus,
  payload: z.record(z.unknown()).nullable(),
  message: z.string().max(2000).nullable(),
  occurredAt: IsoDateTime,
  createdAt: IsoDateTime,
});
export type CommandResult = z.infer<typeof CommandResult>;

export const CommandListFilters = PageQuery.extend({
  deviceId: Id.optional(),
  assetId: Id.optional(),
  status: CommandStatus.optional(),
  commandType: CommandType.optional(),
  requestedFrom: IsoDateTime.optional(),
  requestedTo: IsoDateTime.optional(),
});
export type CommandListFilters = z.infer<typeof CommandListFilters>;

export const CommandCreateInput = z.object({
  commandType: CommandType,
  parameters: z.record(z.unknown()).default({}),
});
export type CommandCreateInput = z.infer<typeof CommandCreateInput>;

export const CommandStatusResponse = z.object({
  request: CommandRequest,
  results: z.array(CommandResult),
});
export type CommandStatusResponse = z.infer<typeof CommandStatusResponse>;

export const CommandListResponse = Page(CommandRequest);
export type CommandListResponse = z.infer<typeof CommandListResponse>;
